import React, { Fragment, useRef } from 'react';
import PnIcon from './PnIcon';

const QuantityButtons = ({ onCartItemDecrement, onCartItemIncrement, updateQuantity, quantityRef, inputVal }) => {

    if (!quantityRef) {
        quantityRef = useRef(null);
    }

    return (
        <div className="cart__product-row__quantity">
            <button
                className="cart__product-row__quantity-action decrease"
                onClick={onCartItemDecrement}>
                <PnIcon iconName="remove" title="cart" width="12" height="12" cssClass="" />
            </button>
            <div className="cart__product-row__quantity-display">
                <input ref={quantityRef} onChange={(e) => updateQuantity(e)} className="input form__input" type="number" min="1" maxLength={3} value={inputVal} />
            </div>
            <button
                className="cart__product-row__quantity-action cart__product-row__quantity-action--plus increase"
                onClick={onCartItemIncrement}>
                <PnIcon iconName="add" title="cart" width="12" height="12" cssClass="" />
            </button>
        </div>
    );

};

export default QuantityButtons;
